import React, { FC, useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router'
import Utils from '../../core/Utils'
import { useTranslation } from '../../hooks/useTranslation'
import { Smartico } from '../../core/Smartico'

interface MatchxQuizPageProps {
	gameType: string
}

const MatchxQuizPage: FC<MatchxQuizPageProps> = ({ gameType }) => {
	const isMobile = Utils.isMobile()
	const { id } = useParams<{ id: string }>()
	const navigate = useNavigate()

	const frameRef = useRef<HTMLIFrameElement>(null)
	const { getTexts, selectedLanguage } = useTranslation(true)

	useEffect(() => {
		let timeoutId: number

		const initGameInNewLanguage = async () => {
			await Smartico.apiReady

			timeoutId = window.setTimeout(() => {
				if (id && frameRef.current) {
					(window as any)._smartico.miniGame(id, {
						iframe: 'frame1',
						zoom: 1,
						height: gameType === 'quiz' ? '594px' : '1000px',
						theme: 'v3_ice_2024',
						gameType: gameType,
					})
				}
			}, 1200)
		}

		initGameInNewLanguage()

		return () => {
			clearTimeout(timeoutId)
		}
	}, [selectedLanguage, id, gameType])

	return (
		<div className="main-content matchx-quiz-page">
			{!isMobile && (
				<div onClick={() => navigate(-1)} className="back-button">
					<div className="icon"></div>
					{getTexts('back')}
				</div>
			)}
			<iframe ref={frameRef} id="frame1" style={{ width: '100%', height: '100%', borderRadius: '6px' }} title="Game Frame"></iframe>
		</div>
	)
}

export default MatchxQuizPage
